<script setup>
import Step1Icon from "@/assets/images/desktop/process/use.svg";
import Step2Icon from "@/assets/images/desktop/process/Group_3830.svg";
import Step3Icon from "@/assets/images/desktop/process/Group_3868.svg";
import Step4Icon from "@/assets/images/desktop/process/Group_3871.svg";
import Step5Icon from "@/assets/images/desktop/process/Group_3870.svg";
import Step6Icon from "@/assets/images/desktop/process/Group_3869.svg";
import MobileArrow from "@/assets/images/mobile/advantage/Group_3918.svg";

const steps = [
  {
    step: "Step.1",
    name: "使用",
    icon: Step1Icon,
    desc: "進入Messenger，點擊開始，開啟代買服務。",
  },
  {
    step: "Step.2",
    name: "委託",
    icon: Step2Icon,
    desc: "填寫委託單，貼上商品連結，填寫好收件資訊，並送出申請。",
  },
  {
    step: "Step.3",
    name: "報價",
    icon: Step3Icon,
    desc: "收到委託單，將在兩個工作天內完成估價。",
  },
  {
    step: "Step.4",
    name: "付款",
    icon: Step4Icon,
    desc: "我們會提供您匯款資訊，請於 24 小時內完成付款。",
    row2: true, // Marker for 2nd row in desktop layout logic
    desktopOrder: 3, // Reverse order for 2nd row in desktop layout visual
  },
  {
    step: "Step.5",
    name: "寄送",
    icon: Step5Icon,
    desc: "1688 廠商會進行出貨，同時，也請您事先做好EZ WAY易利委申報，以利加快商品通關。",
    row2: true,
    desktopOrder: 2,
  },
  {
    step: "Step.6",
    name: "取貨",
    icon: Step6Icon,
    desc: "開箱時，別忘記拍照或錄影，後續有爭議時，以利向1688 廠商溝通唷！",
    row2: true,
    desktopOrder: 1,
  },
];

// Split steps for desktop 2-row layout
const row1Steps = steps.filter((_, i) => i < 3);
const row2Steps = steps.filter((_, i) => i >= 3).reverse(); // Reverse for display order 6-5-4
</script>

<template>
  <section class="process-section">
    <div class="process-bg-wrapper">
      <picture>
        <source
          media="(min-width: 1060px)"
          srcset="@/assets/images/desktop/process/Vector.png"
        />
        <img
          style="width: 100%"
          src="@/assets/images/desktop/process/Vector.svg"
          alt="灰底"
        />
      </picture>

      <div class="gray-bk">
        <div class="process-title-container">
          <img
            class="process-deco"
            src="@/assets/images/desktop/process/right.svg"
            alt=""
          />
          <p class="step-title1">代買流程</p>
          <img
            class="process-deco"
            src="@/assets/images/desktop/process/left.svg"
            alt=""
          />
        </div>

        <!-- Desktop Layout -->
        <div class="process-steps-desktop">
          <!-- Row 1: Steps 1, 2, 3 -->
          <div class="process-row">
            <template v-for="(step, index) in row1Steps" :key="step.step">
              <div class="box">
                <div class="step-number-photo">
                  <div class="Step-number">
                    <p>{{ step.step }}</p>
                    <p>{{ step.name }}</p>
                  </div>
                  <img :src="step.icon" :alt="step.name" />
                </div>
                <p>{{ step.desc }}</p>
              </div>
              <!-- Add Arrow unless it's the last item in the row -->
              <div
                v-if="index < row1Steps.length - 1"
                class="arrow-purchase"
              ></div>
            </template>
            <img
              class="process-curve"
              src="@/assets/images/desktop/process/Group_3872.svg"
              alt=""
            />
          </div>

          <!-- Row 2: Steps 6, 5, 4 (Reversed visual order) -->
          <div class="process-row down">
            <template v-for="(step, index) in row2Steps" :key="step.step">
              <div class="box">
                <div class="step-number-photo">
                  <div class="Step-number">
                    <p>{{ step.step }}</p>
                    <p>{{ step.name }}</p>
                  </div>
                  <img :src="step.icon" :alt="step.name" />
                </div>
                <p>{{ step.desc }}</p>
              </div>
              <!-- Add Arrow unless it's the last item in the row -->
              <div
                v-if="index < row2Steps.length - 1"
                class="arrow-purchase"
              ></div>
            </template>
          </div>
        </div>

        <!-- Mobile Layout -->
        <div class="process-steps-mobile">
          <template v-for="(step, index) in steps" :key="step.step">
            <div class="box-mo">
              <div class="step-number-photo-mo">
                <div class="Step-number-mo">
                  <p>{{ step.step }}</p>
                  <p>{{ step.name }}</p>
                </div>
                <img :src="step.icon" :alt="step.name" />
              </div>
              <p>{{ step.desc }}</p>
            </div>
            <!-- Arrow between mobile steps -->
            <img
              v-if="index < steps.length - 1"
              class="arrow-mo"
              :src="MobileArrow"
              alt="箭頭"
            />
          </template>
        </div>
      </div>
      <picture>
        <source
          media="(min-width: 1060px)"
          srcset="@/assets/images/desktop/process/Vector2.png"
        />
        <img
          style="width: 100%; margin-top: -2px"
          src="@/assets/images/desktop/process/Vector2.svg"
          alt="灰底"
        />
      </picture>
    </div>
  </section>
</template>

<style scoped>
/* Process Section */
.process-section .gray-bk {
  background-color: #f1f3fa;
  height: auto;
  min-height: 1634px;
  position: relative;
  margin-top: -1px;
}

.process-title-container {
  display: flex;
  padding-top: 66px;
  padding-bottom: 36px;
  justify-content: center;
}

.step-title1 {
  font-weight: 800;
  font-size: 26px;
  transform: scaleY(1.05);
  color: #343a40;
  margin: 0;
  padding-left: 24px;
  padding-right: 24px;
}

.process-steps-desktop {
  display: none;
}

.process-steps-mobile {
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  padding-bottom: 50px;
}

.box-mo {
  border: 1px solid #ced6ff;
  background-color: #ffffff;
  border-radius: 20px;
  padding: 20px;
  max-width: 250px;
  box-shadow: 0 0.5px 30px 0 rgba(241, 238, 238, 0.496);
  min-width: 242px;
  min-height: 200px;
}

.step-number-photo-mo {
  display: flex;
  justify-content: space-between;
}

.step-number-photo-mo > img {
  margin-top: -20px;
}

.Step-number-mo > p:nth-child(1) {
  font-weight: 600;
  font-size: 16px;
  color: #2aa5ff;
}

.Step-number-mo > p:nth-child(2) {
  font-weight: 600;
  font-size: 24px;
  color: #060e57;
  margin-top: -1rem;
}

.box-mo > p {
  font-size: 15px;
  color: #495057;
}

.arrow-mo {
  display: block;
  margin: 0 auto;
  margin-bottom: 6px;
}

.process-deco {
  display: none;
}

/* Desktop Styles */
@media (min-width: 1060px) {
  .process-section .gray-bk {
    height: 787px;
    min-height: auto;
  }

  .process-title-container {
    padding-top: 66px;
  }

  .step-title1 {
    font-size: 38px;
    padding-left: 22px;
    padding-right: 22px;
  }

  .process-steps-mobile {
    display: none;
  }

  .process-steps-desktop {
    display: block;
    position: relative;
    width: fit-content;
    margin: 0 auto;
  }

  .process-row {
    display: flex;
    justify-content: center;
  }

  .box {
    border: 1px solid #ced6ff;
    background-color: #ffffff;
    border-radius: 20px;
    padding: 20px;
    max-width: 250px;
    box-shadow: 0 0.5px 30px 0 rgba(241, 238, 238, 0.496);
    margin: 3rem 1.5rem;
    min-width: 242px;
    min-height: 200px;
  }

  .step-number-photo {
    display: flex;
    justify-content: space-between;
  }

  .step-number-photo > img {
    margin-top: -20px;
  }

  .Step-number > p:nth-child(1) {
    font-weight: 600;
    font-size: 16px;
    color: #2aa5ff;
  }

  .Step-number > p:nth-child(2) {
    font-weight: 600;
    font-size: 24px;
    color: #060e57;
    margin-top: -1rem;
  }

  .box > p {
    font-size: 15px;
    color: #495057;
  }

  .arrow-purchase {
    position: relative;
    width: 40px;
    height: 18px;
    background-color: #ced6ff;
    margin-top: 150px;
  }

  .arrow-purchase:after {
    content: "";
    position: absolute;
    top: -11px;
    right: -10px;
    border-top: 20px solid transparent;
    border-bottom: 20px solid transparent;
    border-left: 30px solid #ced6ff;
    border-color: transparent transparent transparent #ced6ff;
  }

  /* Reversed arrow for bottom row */
  .down > .arrow-purchase:after {
    left: -10px;
    right: auto;
    border-left: none;
    border-right: 30px solid #ced6ff;
    border-color: transparent #ced6ff transparent transparent;
  }

  /* Refine Arrows Position based on flex context */
  .process-row:not(.down) .arrow-purchase {
    /* flex gap handles margin, arrow is an item */
    margin-left: -0.5rem; /* Tweak spacing if needed */
    margin-right: -0.5rem;
  }

  .process-curve {
    position: absolute;
    top: 25%;
    right: -40px;
  }
}
</style>
